module.exports = __webpack_public_path__ + "static/media/logo-dark.bcf3c381.svg";